export default function SubItemDirective() {
  return {
    template: require('./subItem.html'),
    scope: {
      item: '=',
      canEdit: '=',
      canDelete: '=',
      agendaIsActive: '=',
      canChangeStatus: '='
    },
    controller: 'SubItemController',
    controllerAs: 'subItemVM',
    bindToController: true,
    replace: true
  };
}
